import { DigestFilterColumn, DigestFilterOperator } from "../../CandyApiClient/DigestApiClient/Types/DigestQueryFilter";
import { isNullOrEmpty } from "../../TypingUtils";

export const serializeToString = (filter?: DigestFilterColumn, isTree?: boolean): string => {
    if (filter == undefined || (isNullOrEmpty(filter?.value) && !isTree)) {
        return "";
    }

    const valueString = serializeValueToString(filter.value);
    let result = "(" + filter.column;
    const operatorString = serializeOperatorToString(filter.operator);

    switch (filter.operator) {
        case DigestFilterOperator.Equal:
        case DigestFilterOperator.ContainsInList:
            result += operatorString + valueString;
            break;
        case DigestFilterOperator.Substring:
            result += operatorString + "*" + valueString + "*";
            break;
        case DigestFilterOperator.Prefix:
            result += operatorString + valueString + "*";
            break;
    }

    return result + ")";
};

const serializeValueToString = (value: string): string => {
    let result = value?.toString() ?? "";
    const escapeQuote = "'";

    result = result.replace(/\\/g, "\\\\");
    result = result.replace(escapeQuote, "\\" + escapeQuote);
    return escapeQuote + result + escapeQuote;
};

const serializeOperatorToString = (operator: DigestFilterOperator): string => {
    switch (operator) {
        case DigestFilterOperator.Equal:
            return "=";
        case DigestFilterOperator.ContainsInList:
            return "@";
        case DigestFilterOperator.Substring:
        case DigestFilterOperator.Prefix:
            return "~";
        default:
            return "";
    }
};
